export let ButtonVariant = /*#__PURE__*/function (ButtonVariant) {
  ButtonVariant["Contained"] = "contained";
  ButtonVariant["Outlined"] = "outlined";
  return ButtonVariant;
}({});
export default ButtonVariant;